import router from '../router'
import { getPersonalInfoByMemberId } from 'api/user'

function checkUA() {
    return true;
    // var ua = window.navigator.userAgent;
    // if(ua.indexOf("KHealth_iOS") > -1 || ua.indexOf("KHealth_Android") > -1){
    //     UAflag = true;
    //     return true;
    // }
}

function getMemberInfo(data) {
    return new Promise((resolve,reject) => {
        let params = {
            memberCode: data.memberCode,
        }
        getPersonalInfoByMemberId(params).then(res => {
            let obj = {
                jwtToken: data.jwtToken,
                staffCode: data.staffCode
            }
            sessionStorage.setItem("user",JSON.stringify(obj));
            if(res.success) {
                resolve(res.content)
            }else{
                reject(res.message)
            }
        })
    })
}

function writeObj(obj){
    var description = "";
    for(var i in obj){
    var property=obj[i];
    // if(typeof property == 'object'){
    //     writeObj(property)
    // }
    description+=i+" = "+property+"\n";
    }
    document.write(description);
}


// checkUA()
// !跳转到/appBridge/ORG0000000000001页面，APP就会调用我这个方法。
window.KHGetUserInfo = function(data){
    console.log('APP传参', data)
    if(checkUA() && data){
        if(data.environment == 1) {
            let obj = {
                jwtToken: data.jwtToken,
                staffCode: data.staffCode
            }
            sessionStorage.setItem('user',JSON.stringify(obj));
            if(data.type ==  0 || data.type == 1){
                let params = {
                    memberCode: data.memberCode,
                }
                getPersonalInfoByMemberId(params).then(res => {
                    if(res.success) {
                        sessionStorage.setItem("member",JSON.stringify(res.content));
                        if(data.type == 0) { // 测评记录
                            router.push('/evalRecord/index/ORG0000000000001');
                            // router.replace({path: '/evalRecord/index/ORG0000000000001', query: {memberCode: res.content.memberCode}});
                        }
                        if(data.type == 1) { // 指导方案
                            router.push({path: '/guideRecord/index/ORG0000000000001', query: {memberCode: res.content.memberCode}});
                        }
                    }else{
                        document.write(res.message)
                    }
                }).catch((error) =>{
                    document.write(error)
                })
            }

            if(data.type === 2 || data.type === 3) {

                let obj = {
                    jwtToken: data.jwtToken,
                    staffCode: data.staffCode
                }
                sessionStorage.setItem("user",JSON.stringify(obj));
                getMemberInfo(data).then(res => {
                    sessionStorage.setItem("member",JSON.stringify(res));
                    if(data.type == 2) {
                        if (data.businessData.resultId) {
                            router.replace({
                                path:'/evalRecord/result/result/ORG0000000000001',
                                query: {
                                    appSurveyAnswerId:data.businessData.resultId,
                                }
                            })
                            return false
                        }
                        router.replace({
                            path:'/evalRecord/assess/assess/ORG0000000000001',
                            query: {
                                appSurveyId:data.businessData.appSurveyId,
                                projectSurveyName:data.businessData.projectSurveyName,
                                surveyCount:data.businessData.surveyCount,
                                questioncount: data.businessData.questioncount,
                                expectedTime: data.businessData.expectedTime,
                                expectedtimeunit: data.businessData.expectedtimeunit
                            }
                        });
                    }
                    if(data.type == 3) {
                        if (data.businessData.resultId) {
                            router.replace({
                                path:'/evalRecord/result/results/ORG0000000000001',
                                query: {
                                    appSurveyAnswerId:data.businessData.resultId,
                                    memberCode: data.memberCode
                                }
                            })
                            return false
                        }
                        router.replace({
                            path:'/evalRecord/assess/assesss/ORG0000000000001',
                            query: {
                                appSurveyId:data.businessData.appSurveyId,
                                projectSurveyName:data.businessData.projectSurveyName,
                                surveyCount:data.businessData.surveyCount,
                                questioncount: data.businessData.questioncount,
                                expectedTime: data.businessData.expectedTime,
                                expectedtimeunit: data.businessData.expectedtimeunit
                            }
                        });
                    }
                })
            }

            if(data.type == 4){
                var obj = {
                    jwtToken: data.jwtToken,
                    staffCode: data.staffCode
                }
                sessionStorage.setItem("user",JSON.stringify(obj));
                router.push({
                    path: '/platform/guidePlan/index/ORG0000000000001'
                })
            }
        }
    }
}

window.KHGetSuveryProjectInfo = function(data) {
    if(checkUA() && data) {
        if(data.type == 'doctor'){
            sessionStorage.setItem("user",JSON.stringify(data.doctor))
            sessionStorage.setItem("member",JSON.stringify(data.user))
            router.replace({
                path:data.src,
                query: {
                    appSurveyId:data.appSurveyId,
                    projectSurveyName:data.projectSurveyName,
                    surveyCount:data.surveyCount,
                    questioncount: data.questioncount,
                    expectedTime: data.expectedTime,
                    expectedtimeunit: data.expectedtimeunit
                }
            });
        }
    }
}

window.getKHSuveryResult = function(data) {
    var obj = {};
    if(checkIA() == 'iOS'){
        obj.url = KHbase.url + `${data.url}?memberCode=${data.memberCode}&appSurveyAnswerId=${data.appSurveyAnswerId}`;
        obj.title = data.title;
        window.webkit.messageHandlers.KHGetSurveryResult.postMessage(obj)
    }
    if(checkIA() == 'Android'){
        obj.url = KHbase.url + `${data.url}?memberCode=${data.memberCode}&appSurveyAnswerId=${data.appSurveyAnswerId}`;
        // obj.url = KHbase.url + `/#/record/eval/result/ORG0000000000001?memberCode=${data.memberCode}&appSurveyAnswerId=${data.appSurveyAnswerId}`;
        obj.title = data.title;
        window.AndroidWebView.KHGetSurveryResult(obj)
    }
}

// 识别手机系统iOS/Android
function checkIA(){
    var ua = window.navigator.userAgent;
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(ua.indexOf("KHealth_iOS") > -1){
        return 'iOS'
    }else if(ua.indexOf("KHealth_Android") > -1){
        return 'Android'
    }else{
        return 'PC'
    }
}

window.getKHSuveryResult = function(data) {
    var obj = {};
    if(checkIA() == 'iOS'){
        obj.url = KHbase.url + `${data.url}?memberCode=${data.memberCode}&appSurveyAnswerId=${data.appSurveyAnswerId}`;
        obj.title = data.title;
        window.webkit.messageHandlers.KHGetSurveryResult.postMessage(obj)
    }
    if(checkIA() == 'Android'){
        obj.url = KHbase.url + `${data.url}?memberCode=${data.memberCode}&appSurveyAnswerId=${data.appSurveyAnswerId}`;
        // obj.url = KHbase.url + `/#/record/eval/result/ORG0000000000001?memberCode=${data.memberCode}&appSurveyAnswerId=${data.appSurveyAnswerId}`;
        obj.title = data.title;
        window.AndroidWebView.KHGetSurveryResult(obj)
    }
}

function beJSON(JSONString){
    try {
        var data = JSON.parse(JSONString)
    } catch (error) {
        data = "";
    } finally {
        return data
    }
}

function test(){
    //⽅法khSelectAddress()括号内若⽆参数，则传null，若不传则⽆响应(调⽤iOS端⽅法失败)
    window.webkit.messageHandlers.KHSurveryResult.postMessage(null)
}

// 获取医生订单
window.KHGetDoctorUserInfo = function(data){
    // document.write(data.jwtToken);
    let user={
        jwtToken:data.jwtToken
    }
    sessionStorage.setItem("user",JSON.stringify(user));
    // document.write(sessionStorage.getItem('user'))
    router.replace({
        path:'/doctor/doctorOrder/ORG0000000000001',
        query: {
            staffCode: data.staffCode,
        }
    })
}



// WEBPACK FOOTER //
// ./src/appBridge/index.js